const CONFIG = {
    devMode: false,        // set to true to bypass location and desktop checks
    devLocation: false,    // set to true to bypass location check on desktop
    demo: false,          
    StripeAPI: '', // set to true to use the demo API endpoint
    GoogleMapAPI: 'AIzaSyABX4QTBapTN9xlxsq1blkP2LudNZKMf3U',
    passUrl: (false || false || false)
      ? 'https://app-salto-bookmy.remote.beetleblack.com.au'
      : 'https://app-salto-bookmy.remote.beetleblack.com.au',
    lottieUrl: 'https://app-salto-bookmy.remote.beetleblack.com.au/businesses-lottie-logo/',
    apiUrl: 'https://app.slbp.smartlockbooking.com.au/slb-app/api.php',
      // : 'https://app-salto-bookmy.remote.beetleblack.com.au/slb-app/api.php',
    dotnetURL: 'https://api.smartlockbooking.com.au/api/v1',
    // dotnetURL: 'https://api-slbp.remote.beetleblack.com.au/api/v1'
  };
  export { CONFIG };
  //'https://app-salto-bookmy.remote.beetleblack.com.au/slb-app/api.php'
  //'https://app.slbp.smartlockbooking.com.au/slb-app/api.php' 